import { render, staticRenderFns } from "./SendMessageSettings.vue?vue&type=template&id=54131317&"
import script from "./SendMessageSettings.vue?vue&type=script&lang=js&"
export * from "./SendMessageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports